webModule.controller('LoginController',
    ['$rootScope', '$scope', '$location', 'userAuthenticateService', 'identityMgmntService', 'imSessionVarsService',
        'usersEditService', 'usersSearchService', 'dealershipService', 'growl', 'routes',
        'authorizationService', 'rolePermissionsService','commonTLCService','quoteIntegrationService',
        'rateQuoteCoordService','TLCError','AppErrorCodes','vehicleDefinitionService', 'providerFeaturesService',
        'usageEventsService',
    function ($rootScope, $scope, $location, userAuthenticateService, identityMgmntService, imSessionVarsService,
              usersEditService, usersSearchService, dealershipService, growl, routes,
              authorizationService, rolePermissionsService,commonTLCService,quoteIntegrationService,
              rateQuoteCoordService, TLCError, AppErrorCodes, vehicleDefinitionService, providerFeaturesService,
              usageEventsService) {

        $scope.loginCred = {};
        $scope.reset = {};
        $scope.change = {};
        $scope.activeSection = ""; // one of: 'login', 'signup', 'change', 'reset'
        $scope.counter = 0;

        // Messages for password change and reset are in $scope, so that they can be configured per provider if desired.
        $scope.reset.prompt = "To reset your password, please enter your login id and email address on file. \
    If that matches our records, a new temporary password will be emailed to you. \
    You will be required to change this password at your next login.";

        $scope.reset.successMessage = "Password reset successfully. You should receive an email with the new password shortly.";
        $scope.reset.loginMessage = "You may then click {here} to login.";

        $scope.change.successMessage = "Password changed successfully. You will receive a confirmation email shortly.";
        $scope.change.continueMessage = "Click {here} to continue.";


        $scope.login = function () {
            var credTemplate = {};
            //verify that we have retrieved the roles
            var userRoleRouteMap = imSessionVarsService.getRolesAndPrivileges();
            if (userRoleRouteMap == null){
                rolePermissionsService.generateUserRoleRouteMap();
            }
            userAuthenticateService.getCredentialTemplate().success(function (response) {
                credTemplate = response;
                credTemplate.UserName = $scope.loginCred.UserName;
                credTemplate.Password = $scope.loginCred.Password;
                credTemplate.MarketId = 'RISTKENSOFTWARE';
                credTemplate.TimeoutLengthMinutes = 24 * 60; //24 hour token lifetime

                userAuthenticateService.authenticateCredentials(credTemplate)
                    .success(function (response) {
                        userAuthenticateService.setUserToken(response.TokenValue);
                        userAuthenticateService.setUserId(response.Id); // IM Id
                        usersSearchService.retrieveCurrentUser()
                            .then(function(user){
                                imSessionVarsService.setCurrentIMUser(user);
                                imSessionVarsService.setCurrentIMUserRoles(user.Claims);
                            });

                        identityMgmntService.getUserProvider()
                            .then(function (provider) {
                                imSessionVarsService.setCurrentProviderId(provider.Id);
                                imSessionVarsService.setCurrentProviderCode(provider.ProviderCode);
                                //KRE - Retrieving ALL the provider settings from DB (this settings will be manage in the future by the Settings View
                                //providerFeaturesService.getProviderApplicationSetting('UI-RequiredAccess')
                                providerFeaturesService.getProviderApplicationSettings()
                                    .then(function(elements) {
                                        // set the cache
                                        //imSessionVarsService.setCurrentProviderUIRequiredAccess(elements);
                                        imSessionVarsService.setCurrentProviderSettings(elements);
                                        if (response.PasswordChangeNeeded) {
                                            $scope.activateChangeSection();
                                        } else {
                                            $scope.loginComplete();
                                        };
                                    });

                            });
                    })
                    .error(function (response, status, headers, config) {
                        if(status != 200) {
                            $scope.loginMessage = 'Authentication failed';
                        }
                        else
                            throw new TLCError(new Error(response), AppErrorCodes.LoginController_NotAuthenticated);
                    });
            }).error(function (response, status, headers, config) {
                throw new TLCError(new Error(response), AppErrorCodes.Global_Unknown);
            });
        };

        $scope.loginComplete = function() {
            // clear out dealer name so they don't see any remnants of old logins
            dealershipService.dealershipInfo.name = '';

            var usr = imSessionVarsService.getCurrentIMUser();
            var provcode = imSessionVarsService.getCurrentProviderCode();

            usageEventsService.userChanges(usr);

            dealershipService.getUserDealerships(0,10)//only need to know if user has more than 1 dealer
                .then(function(responseDealerships) {
                    if (responseDealerships.length === 1) {
                        var dealerInfo = responseDealerships[0];

                        usageEventsService.dealerChanges(dealerInfo.id);

                        try {
                            commonTLCService.setupEssentialDealerVars(dealerInfo)
                                .then(function() {
                                    //clear out any "stale" state information
                                    rateQuoteCoordService.startNewQuoteSession(true,true,true,true);
                                    quoteIntegrationService.clearIntegrationData();
                                    vehicleDefinitionService.vehicleDetailsData.ready = false;

                                    $location.url(routes.createQuote);
                                }),
                                function(err) {
                                    throw new TLCError(err, AppErrorCodes.Global_Unknown);
                                }

                        }
                        catch (ex) {
                            // This should not happen
                            switch (ex) {
                                case "ACCOUNT-NOT-FOUND":
                                    throw new TLCError(new Error('Could not find dealer account code for dealer: ' + dealerInfo.name), AppErrorCodes.Dealer_Not_Found, this);
                                case "SPANID-NOT-FOUND":
                                    throw new TLCError(new Error('Could not find dealer SPAN id for  dealer: ' + dealerInfo.name), AppErrorCodes.Dealer_Not_Found, this);
                            }
                            throw new TLCError(ex, AppErrorCodes.Dealer_Not_Found);
                        }
                    }
                    else if (responseDealerships.length > 1) {
                        $location.path(routes.dealershipSearch);
                    } else {
                        $location.path(routes.dealershipSearch);
                    }
                }, function(error) {
                    throw new TLCError(new Error(response), AppErrorCodes.Dealer_Not_Found);
                });
        };

        $scope.activateLoginSection = function () {
            $scope.loginCred.UserName = '';
            $scope.loginCred.Password = '';
            $scope.activeSection = "login";
            $scope.loginMessage = '';
        };

        $scope.activateSignupSection = function () {
            $scope.activeSection = "signup";
        };

        $scope.activateResetSection = function () {
            $scope.reset.userName = "";
            $scope.reset.email = "";
            $scope.reset.done = false;
            $scope.activeSection = "reset";
        };

        $scope.activateChangeSection = function () {
            $scope.change.password1 = "";
            $scope.change.password2 = "";
            $scope.change.done = false;
            $scope.activeSection = "change";
        };

        $scope.resetPassword = function () {
            var resetParameters = {UserName: $scope.reset.userName, Email: $scope.reset.email};
            userAuthenticateService.resetPassword(resetParameters)
                .success(passwordResetSuccessful)
                .error(function (response) {
                    throw new TLCError(new Error(response), AppErrorCodes.LoginController_PasswordResetFail);
                    //var message = angular.isString(response) ? response : "Password reset failed";
                    //growl.error(message);
                });
        };

        $scope.changePassword = function () {
            if ($scope.change.password1 == "" || $scope.change.password1 != $scope.change.password2) {
                // This is redundant.  Validation should disable the button to save changes
                throw new TLCError(new Error("Entered passwords must not be empty, and must be identical"), AppErrorCodes.LoginController_PasswordResetValidation);
            }
            var imId = userAuthenticateService.getUserId();
            var newPassword = $scope.change.password1;
            usersEditService.changePassword(imId, newPassword)
                .success(passwordChangeSuccessful)
                .error(function (response) {
                    throw new TLCError(new Error(response), AppErrorCodes.LoginController_PasswordResetFail);
                });
        };

        $scope.clearPassword = function(){
            $scope.loginCred.Password = '';
            $scope.loginMessage = '';
        }


        function passwordResetSuccessful() {
            $scope.reset.done = true; // enable done message  & link
        }

        function passwordChangeSuccessful() {
            $scope.change.done = true; // enable done message & link
        }

        function init() {
            $scope.activateLoginSection();
            $scope.reset.userName = "";
            $scope.reset.email = "";
            $scope.change.password1 = "";
            $scope.change.password2 = "";
            userAuthenticateService.clearUserToken();
            rolePermissionsService.generateUserRoleRouteMap();
            quoteIntegrationService.clearIntegrationData()
            vehicleDefinitionService.vehicleDetailsData.ready = false;
        }

        $rootScope.$on("$routeChangeStart", function(event, next, current) {
            var newValue = next.originalPath
            if (newValue.substr(newValue.length -1,1) == '/'){
                newValue = newValue.substr(0, newValue.length - 1);
            }
            if(!authorizationService.isUrlAccessibleForUser(newValue))
                $location.path(routes.login);
        });

        init();
    }
]);
